import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return "topela : Plateforme d'échange entre professionnels et clients"
} 